<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label for="form-application-meeting-person-phone" class="control-label">{{ inputLabel }}</label>
    <phone-input
      id="form-application-meeting-person-phone"
      :disabled="disabled"
      v-model="inputValue"
      :placeholder = "'+7 812 345-67-89'"
      @input="emitValue('input', $event)"
      @change="emitValue('change', $event)"
      @blur="emitValue('blur', $event)"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import organizationSectionMixin from '../../../../mixins/application-form/organizationSectionMixin'
import organizationInputMixin from '../../../../mixins/application-form/organizationInputMixin'
import PhoneInput from '../../../inputs/PhoneInput.vue'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'MeetingPersonPhoneInput',

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    organizationSectionMixin,
    organizationInputMixin
  ],

  components: {
    Hint,
    PhoneInput
  },

  props: {
    inputLabel: {
      default: 'Телефон встречающего'
    },

    inputName: {
      default: 'meeting_person_phone'
    },

    inputHint: {
      default: undefined
    }
  }
}
</script>
